import Constants from 'expo-constants';

export default function isInvenzi() {
  const slug = Constants.expoConfig?.slug;
  return slug === 'myInvenzi';
}
